import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthData } from "../../auth/AuthWrapper";
import CommonIcon from '../common/customicon';
import { nav } from "./navigation";
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { API_SUCCESS_RESPONSE_CODE, PRODUCT_NAME, AUTH_TOKEN_REFRESH_DURATION } from "../../utils/config_mapping";
import { apiCall } from "../../utils/server_utils";
import { trackError } from "../../utils/error_tracker";
import { getUsername } from "../../utils/common_functions";
import { Link,useLocation} from 'react-router-dom'; // Import Link from react-router-dom

const app_client = process.env.REACT_APP_CLIENT;

export const RenderRoutes = () => {
    const { user } = AuthData();
    return (
        <Routes>
            {nav.map((r, i) => {
                if (r.isPrivate && user.isAuthenticated) {
                    return <Route key={i} path={r.path} element={r.element} />;
                } else if (!r.isPrivate) {
                    return <Route key={i} path={r.path} element={r.element} />;
                } else return false;
            })}
        </Routes>
    );
};


export const RenderMenuLeft = () => {
    const { user,isLoggedIn, logout } = AuthData();
    const [isMenuSmall, setIsMenuSmall] = useState(false); // Tracks menu size
   
    const toggleMenu = () => {
        const htmlElement = document.documentElement; // Refers to the <html> tag
        const currentMenuStatus = htmlElement.getAttribute('data-sidebar-size');
        const menuStatus = currentMenuStatus === 'sm' ? 'lg' : 'sm';
        htmlElement.setAttribute('data-sidebar-size', menuStatus);
        setIsMenuSmall(!isMenuSmall); // Update the state
    };

  // Function to refresh the auth token
  const refreshAuthToken = async () => {
    let apiUrl = API_SERVER_URL+ 'refresh-access-token/'
    let method = "POST"
    try {
        const result = await apiCall(method,apiUrl);
        if(result!==undefined){
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
            let jsondata = localStorage.getItem("jsondata")
            if(jsondata!==undefined && jsondata!== null){
                const jsonData = JSON.parse(jsondata);
                if(result.data.access_token!==undefined){
                    jsonData.accessToken =result.data.access_token
                    localStorage.setItem("jsondata",JSON.stringify(jsonData))
                 }
            }
        } else {
          trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
        }
        }
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  };
  refreshAuthToken();
  useEffect(() => {
    // Call the token refresh function immediately when the component mounts
    refreshAuthToken();

    // Set an interval to refresh the token every 15 minutes (900,000 milliseconds)
    //const interval = setInterval(refreshAuthToken, 100);

    // Clean up the interval when the component unmounts
    //return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this effect runs once on mount


const logged_user_name = getUsername();

return(<>
     <div className="app-menu navbar-menu">
            <div className="navbar-brand-box">
                <a href="/document-list" className="logo logo-dark">
                    <span className="logo-sm">
                    <CommonIcon iconName="FileText" color="#fff" /> Contract Genie <sup>TM</sup>
                    </span>
                    <span className="logo-lg">
                    <CommonIcon iconName="FileText" color="#fff" /> Contract Genie <sup>TM</sup>
                    </span>
                </a>
                <a href="/document-list" className="logo logo-light">
                    <span className="logo-sm">
                    <CommonIcon iconName="FileText" color="#fff" />
                    </span>
                    <span className="logo-lg">
                    <CommonIcon iconName="FileText" color="#fff" /> Contract Genie <sup>TM</sup>
                    </span>
                </a>
                <a href="#!" onClick={toggleMenu}>
                <i
                    className={`menu-icon text-right`}
                >
                {isMenuSmall ? 
                <CommonIcon iconName="ChevronRight" size={"17px"} color="#fff"  />:<CommonIcon iconName="ChevronLeft" size={"17px"} color="#fff"  />
                }
                </i>
                </a>
{/* 
                <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
                    <i className="ri-record-circle-line"></i>
                </button> */}
            </div>
            <div id="scrollbar">
                <div className="container-fluid">
                    <div id="two-column-menu">
                    </div>
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link menu-link" href="/document-list">
                            <div class="left-menu left-menu-active">
                            <CommonIcon iconName="FileText" color="#fff" /> <span data-key="t-widgets">Documents</span>
                            </div></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link menu-link disabled-link" href="javascript:void(0)">
                            <div class="left-menu"><CommonIcon iconName="LayoutDashboard" color="#fff" /> <span data-key="t-widgets">Dashboards</span>
                            </div></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link menu-link disabled-link" href="javascript:void(0)">
                            <div class="left-menu"><CommonIcon iconName="Search" color="#fff" /> <span data-key="t-widgets">Repository Search</span>
                            </div></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link menu-link disabled-link" href="javascript:void(0)">
                            <div class="left-menu"><CommonIcon iconName="Bell" color="#fff" /> <span data-key="t-widgets">Alerts</span>
                            </div></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link menu-link disabled-link" href="javascript:void(0)">
                            <div class="left-menu"><CommonIcon iconName="Settings" color="#fff" /> <span data-key="t-widgets">Admin</span>
                            </div></a>
                        </li>
                        {/* <li className="nav-item">
                            <a className="nav-link menu-link disabled-link" href="#sidebarDashboards" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarDashboards">
                            <CommonIcon iconName="Settings" color="#fff" /> <span data-key="t-dashboards">Admin</span>
                            </a>
                            <div className="collapse menu-dropdown" id="sidebarDashboards">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item disabled-link">
                                        <a href="javascript:void(0)" className="nav-link disabled-link" data-key="t-analytics"> Analytics </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="javascript:void(0)" className="nav-link disabled-link" data-key="t-crm"> Analytics </a>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                    </ul>
                </div>
                <div className="login-user-info">
                <div className="user-details">
                    <div>{logged_user_name}</div>
                    <div>Bio World, Inc</div>
                </div>
                <div className="logout" style={{marginLeft:"10px;"}}>
                    <a href="javacript:void(0)" onClick={logout}><span><CommonIcon iconName="LogOut" color="#fff" /></span></a>
                </div>
                </div>
            </div>
            <div className="sidebar-background"></div>
        </div>
        
     </>)
}

export const RenderMenu = () => {
        const { isLoggedIn, logout } = AuthData();
        const MenuItem = ({r}) => {
             return (
                  <div className="menuItem"><Link to={r.path}>{r.name}</Link></div>
             )
        }
        return (
             <div className="menu">
                  { nav.map((r, i) => {
   
                       if (!r.isPrivate && r.isMenu) {
                            return (
                                 <MenuItem key={i} r={r}/>
                            )
                       } else if (user.isAuthenticated && r.isMenu) {
                            return (
                                 <MenuItem key={i} r={r}/>
                            )
                       } else return false
                  } )}
   
                  {user.isAuthenticated ?
                  <div className="menuItem"><Link to={'#'} onClick={logout}>Log out</Link></div>
                  :
                  <div className="menuItem"><Link to={'login'}>Log in</Link></div> }
             </div>
        )
   }